import React from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import { Icon } from '../Icon';
import { DisclaimerFeatureModel } from '../../fetch-data/graphql/types';
import { DisclaimerFeature } from '../Section/features/DisclaimerFeature/DisclaimerFeature';
import { StickyContentContainer } from '../Guide/styles';
import { VWDisclaimerModal } from './VWDisclaimerModal';

const StickyModalContainer = styled(StickyContentContainer)<{
  $isOpen: boolean;
  $hasNavigation: boolean;
}>`
  position: sticky;
  bottom: ${({ $hasNavigation }) => ($hasNavigation ? '110px' : '0px')};
  margin-bottom: 40px;
  background-color: ${({ theme }) => theme.colors.hoverIndicator};
  border-radius: 8px;

  z-index: 2;

  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};

  @media (min-width: ${Breakpoints.b1280}px) {
    bottom: 20px;
  }
`;

const ModalWrapper = styled.div`
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;

  padding: 4px;

  background: none;
  border: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;

  &:hover {
  }
`;

interface StickyDisclaimerModalProps {
  isOpen: boolean;
  disclaimer: DisclaimerFeatureModel | null;
  onClose: () => void;
  hasNavigation: boolean;
}

const enableVWDisclaimerModal = true;

export const StickyDisclaimerModal: React.FC<StickyDisclaimerModalProps> = ({
  isOpen,
  disclaimer,
  onClose,
  hasNavigation,
}) => {
  if (!disclaimer || !isOpen) return null;

  if (enableVWDisclaimerModal)
    return (
      <VWDisclaimerModal
        isOpen={isOpen}
        disclaimer={disclaimer}
        onClose={onClose}
      />
    );

  return (
    <StickyModalContainer $isOpen={isOpen} $hasNavigation={hasNavigation}>
      <ModalWrapper>
        <CloseButton onClick={onClose} aria-label='Close disclaimer'>
          <Icon
            name='Close'
            ignoreDefaultColor={true}
            style={(theme) => ({ color: theme.colors.button.primary.default })}
          />
        </CloseButton>

        <DisclaimerFeature feature={disclaimer} isModal={true} />
      </ModalWrapper>
    </StickyModalContainer>
  );
};
